<div class="row min-vh-100">
  <div class="col-12 col-lg-5 position-relative">
    <div class="content-with-image-main">
      <h1
        class="d-none d-lg-block fwc-700 content-with-image-main__logo"
        header
      >
        <ng-content select="[header]"></ng-content>
      </h1>
      <ng-content select="[content]"> </ng-content>
      <ng-content select="[action]"> </ng-content>
    </div>
  </div>
  <div class="col-lg-7 d-none d-lg-block pe-0 position-relative">
    @if (templateType === 'variant-1') {
    <div class="content-with-image-bg">
      <div class="content-with-image-bg__image-container">
        <img
          class="content-with-image-bg__image"
          src="/assets/images/{{ image.name }}"
          alt="content-with-image"
        />
      </div>
    </div>
    } @if(templateType === 'variant-2'){
    <div class="content-with-image-bg variant-2">
      <img
        class="content-with-image-bg__image variant-2"
        src="/assets/images/{{ image.name }}"
        alt="content-with-image"
      />
    </div>
    }
  </div>
</div>
